import { BigNumber, Signer, ethers } from 'ethers'
import CommonPool from 'abis/CommonPool.json'
import { SendPaymasterTransactionFn } from 'hooks/usePaymaster'
import { encodeFunctionData } from 'viem'

type Params = {
  account: string
  amount: BigNumber
  setPendingTxns: any
  sendPaymasterTransaction: SendPaymasterTransactionFn
  commonPoolAddress: string
}

export async function createCommonPoolClaim(
  chainId: number,
  signer: Signer,
  p: Params,
) {
  const contract = new ethers.Contract(
    p.commonPoolAddress,
    CommonPool.abi,
    signer,
  )
  const calldata = encodeFunctionData({
    abi: CommonPool.abi,
    args: [BigNumber.from(p.amount), p.account, p.account],
    functionName: 'redeem',
  })

  const call: Parameters<typeof p.sendPaymasterTransaction>[0]['call'] = {
    address: p.commonPoolAddress,
    calldata,
  }

  const messageOpts = {
    hideSentMsg: false,
    hideSuccessMsg: false,
  }

  return p?.sendPaymasterTransaction({
    call,
    account: p.account,
    messageOpts,
    setPendingTxns: p.setPendingTxns,
    router: contract,
    payload: [BigNumber.from(p.amount), p.account, p.account],
    method: 'redeem',
  })
}
